import React from 'react';
import styled from 'styled-components';
import { Modal, Table } from 'semantic-ui-react';

const DishInfoModal = ({ title, isOpen, productsRows = [], onClose }) => {
  return (
    <Modal
      style={{ alignSelf: 'center' }}
      open={isOpen}
      centered
      size="small"
      closeIcon
      onClose={onClose}
    >
      <Modal.Header style={{ textAlign: 'center' }}>
        <Name>{title}</Name>
      </Modal.Header>
      <Modal.Content>
        <Table definition celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Продукт</Table.HeaderCell>
              <Table.HeaderCell>Маленькая порция</Table.HeaderCell>
              <Table.HeaderCell>Средняя порция</Table.HeaderCell>
              <Table.HeaderCell>Увеличенная порция</Table.HeaderCell>
              <Table.HeaderCell>Большая порция</Table.HeaderCell>
              <Table.HeaderCell>Мера веса</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {productsRows.map((product, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={product.product_id + i}>
                <Table.Cell>{product.name}</Table.Cell>
                <Table.Cell>{product.small}</Table.Cell>
                <Table.Cell>{product.medium}</Table.Cell>
                <Table.Cell>{product.big}</Table.Cell>
                <Table.Cell>{product.large}</Table.Cell>
                <Table.Cell>{product.measure}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
};

export default DishInfoModal;

const Name = styled.p`
  font-size: 20px;
  align-items: center;
  color: #17a560;
  margin: 0;
  word-break: break-all;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/DishInfoModal/index.js